module.exports = __webpack_public_path__ + "static/google-ae1eeacea955b0beca7c76b376c312c6.svg";